// TODO: remove this file and set these options via the element
// config tool in Phase 3 when we can associate them with types

const Liquids = ['Water', 'Buffer', 'Media', 'Master Mix'];

export default Liquids;
